import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { AbstractCRUD, CRUDService, ExceptionService, PaginatedList, UtilsService } from '../../xform-compat';
import { BasicListModel } from '../../shared/models';
import { catchError } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class ConferenceService extends AbstractCRUD<BasicListModel> implements CRUDService<BasicListModel> {

  constructor(
    exceptionService: ExceptionService,
    http: HttpClient,
    utilsService: UtilsService
  ) {
    super(exceptionService, http, utilsService);
  }

  public getResourcePath(): string {
    return '/rms/conferences';
  }

  /**
   * Creates an conference
   * @param  formData
   */
  public createConference (formData: any) {
    return super.getHTTP()
      .post(`/api/rms/conferences`, formData)
      .pipe(catchError(ex => super.getException().catchBadResponse(ex)));
  }

  /**
   * Get an conference by its Id
   * @param  {number} id
   * @returns Observable
   */
  public getConferenceById(id: number): Observable<BasicListModel> {
    return super.getHTTP()
      .get(`/api/rms/conferences/${id}`)
      .pipe(catchError(ex => super.getException().catchBadResponse(ex)));
  }

  /**
   * Get all conferences
   * @returns Observable
   */
  public getConferences(): Observable<PaginatedList<BasicListModel>> {
    return super.getHTTP()
      .get(`/api/rms/conferences?sort=name&direction=asc&pagesize=999`)
      .pipe(catchError(ex => super.getException().catchBadResponse(ex)));
  }

  /**
   * Updates an existing conference
   * @param formData
   * @param  {number} conferenceId
   */
  public updateConference (formData: any, conferenceId: number) {
    return super.getHTTP()
      .put(`/api/rms/conferences/${conferenceId}`, formData)
      .pipe(catchError(ex => super.getException().catchBadResponse(ex)));
  }
}
